import { Link } from "react-router-dom";

function InternalLink({ to, children })
{
    return <Link className="fw-bold text-decoration-none text-reset" to={to}>{children}</Link>;
}

export default InternalLink;